import React, { Component } from 'react'
import { connect } from 'react-redux'

import { 
    getAllCountries,
    getTotalAccountCharge
} from 'utils'
import DetailsList from 'components/details-list/details-list'
import Button from 'components/button/button'

import {
	openModal,
} from 'state/actions'

import moment from 'moment'

class StatusBilling extends Component {
    getAddress = _ => {
        const {
            account
        } = this.props

        if(!account.billing_address){
            return null
        }

        let billingCountry = null

        if(account.billing_country){
            billingCountry = getAllCountries().find(country => {
                return country.id == account.billing_country
            })
        }

        let address = `${ account.billing_address }, ${ account.billing_city }, ${ account.billing_state } ${ account.billing_postcode } ${ billingCountry ? billingCountry.name : '' }`

        return address
    }

    updateDetails = _ => {
        const {
            openModal
        } = this.props

        openModal('upgrade','account')
    }

    getTotalCharges = _ => {
        const {
            planAndCurrencyData,
            account
        } = this.props

        const totalCharges = getTotalAccountCharge(account, planAndCurrencyData, null, account.billing_is_annual)

        return totalCharges
    }

    render() {
        const {
            account
        } = this.props

        if(!account.isPremium){
            return null
        }

        const detailsColumns = [
            [
                {
                    label: 'Organization name',
                    emptyString: 'organization',
                    value: account.billing_company_name
                },{
                    label: 'Address',
                    emptyString: 'position',
                    value: this.getAddress()
                },{
                    label: 'Card number',
                    emptyString: 'card number',
                    value: account.card_last_four ? `**** **** **** ${ account.card_last_four }` : null
                },{
                    label: `Total ${ account.billing_is_annual ? 'annual' : 'monthly' } charges`,
                    value: this.getTotalCharges()
                },{
                    label: 'Billing frequency',
                    value: account.billing_is_annual ? 'Annually' : 'Monthly'
                }
            ]
        ]

        if(account.coupon_percent_off){
            const discountObject = {
                label: 'Applied discount',
                value: account.coupon_percent_off+'% off'
            }

            if(account.coupon_expiry){
                const expiryMoment = moment(account.coupon_expiry)

                if(expiryMoment.isAfter()){
                    const dateFormat = expiryMoment.isSame(moment(), 'year') ? 'Do MMMM' : 'Do MMMM, Y'

                    discountObject.value += ' (expires '+expiryMoment.format(dateFormat)+')'
                }
            }

            detailsColumns[0].push(discountObject)
        }

        return (
			<div className="widget box help-container">
				<h3>
					Billing details
				</h3>
				<div>
                    <DetailsList
                        type="stakeholder"
                        columns={detailsColumns}
                    />
                    <Button 
                        level="high"
                        size="big"
                        label={account.billing_company_name ? "Update details" : "Add details"}
                        icon="pencil"
                        callback={this.updateDetails}
                    />
				</div>
			</div>
        )
    }
}

const mapStateToProps = state => {
    return {
        planAndCurrencyData: state.auth.planAndCurrencyData
    }
}

export default connect(mapStateToProps, {
    openModal
})(StatusBilling)


// WEBPACK FOOTER //
// ./src/sections/status/status-billing.jsx